<template>
    <div class="header-nav-item" @mouseenter="mouseenterDesktopMenuHandle" @mouseleave="mouseleaveDesktopMenuHandle">
        <button type="button" class="header-nav-link" :class="isActiveDesktopMenu && `active`"
            @click="activeDesktopMenuHandle">
            <span class="header-nav-icon material-symbols-outlined">menu</span>
            <span class="header-nav-text">{{ $t('menu') }}</span>
        </button>

        <div v-if="isActiveDesktopMenu" class="desktop-menu">
            <div class="menu-content">
                <div class="menuContainer">
                    <div class="browseNav" @mouseleave="clearActive">
                        <ul class="browseNavList">
                            <li class="browseNavItem" v-for="(item, index) in menuLevel1" :key="index"
                                @mouseenter="activeMenuLevel1Handle(item)">

                                <a class="browseNavLink" :href="item.externalLink" target="_blank"
                                    v-if="item.externalLink">
                                    <span class="browseNavText">{{ item.name }}</span>
                                    <span class="browseNavArrow">
                                        <span class="material-symbols-outlined">call_made</span>
                                    </span>
                                </a>

                                <div class="browseNavLink" v-else-if="item.items">
                                    <span class="browseNavText">{{ item.name }}</span>
                                    <span class="browseNavArrow">
                                        <span class="material-symbols-outlined">chevron_right</span>
                                    </span>
                                </div>

                                <a class="browseNavLink" v-else :href="item.uri">
                                    <span class="browseNavText">{{ item.name }}</span>
                                </a>

                            </li>
                        </ul>

                        <ul v-if="activeMenuLevel1" class="browseNavList">
                            <li class="browseNavItem" v-for="(item, index) in menuLevel2" :key="index"
                                @mouseenter="activeMenuLevel2Handle(item)">

                                <a class="browseNavLink" :href="item.externalLink" target="_blank"
                                    v-if="item.externalLink">
                                    <span class="browseNavText">{{ item.name }}</span>
                                    <span class="browseNavArrow">
                                        <span class="material-symbols-outlined">call_made</span>
                                    </span>
                                </a>

                                <div class="browseNavLink" v-else-if="item.items">
                                    <span class="browseNavText">{{ item.name }}</span>
                                    <span class="browseNavArrow">
                                        <span class="material-symbols-outlined">chevron_right</span>
                                    </span>
                                </div>

                                <a class="browseNavLink" v-else :href="item.uri">
                                    <span class="browseNavText">{{ item.name }}</span>
                                </a>
                            </li>
                        </ul>

                        <ul v-if="(menuLevel3.length > 0)" class="browseNavList">
                            <li class="browseNavItem" v-for="(item, index) in menuLevel3" :key="index">
                                <a class="browseNavLink" :href="item.externalLink" target="_blank"
                                    v-if="item.externalLink">
                                    <span class="browseNavText">{{ item.name }}</span>
                                    <span class="browseNavArrow">
                                        <span class="material-symbols-outlined">call_made</span>
                                    </span>
                                </a>

                                <div class="browseNavLink" v-else-if="item.items">
                                    <span class="browseNavText">{{ item.name }}</span>
                                    <span class="browseNavArrow">
                                        <span class="material-symbols-outlined">chevron_right</span>
                                    </span>
                                </div>

                                <a class="browseNavLink" v-else :href="item.uri">
                                    <span class="browseNavText">{{ item.name }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props: ['menus'],
    data() {
        // const menus = [];

        return {
            activeMenuLevel1: null,
            activeMenuLevel2: null,

            isActiveDesktopMenu: false
        }
    },

    computed: {
        menuLevel1() {
            return this.menus.map((menu) => menu);
        },
        menuLevel2() {
            if (!this.activeMenuLevel1) {
                return []
            }

            if (!this.activeMenuLevel1.items) {
                return []
            }

            return this.activeMenuLevel1.items.map((menu) => menu)
        },
        menuLevel3() {
            if (!this.activeMenuLevel2) {
                return []
            }

            if (!this.activeMenuLevel2.items) {
                return []
            }

            return this.activeMenuLevel2.items.map((menu) => menu)
        }
    },

    methods: {
        mouseenterDesktopMenuHandle() {
            this.isActiveDesktopMenu = true
        },
        mouseleaveDesktopMenuHandle() {
            this.isActiveDesktopMenu = false
        },
        activeDesktopMenuHandle() {
            this.isActiveDesktopMenu = !this.isActiveDesktopMenu
        },
        activeMenuLevel1Handle(item) {
            this.activeMenuLevel2 = null

            if (item.items) {
                this.activeMenuLevel1 = item
            }
            else {
                this.activeMenuLevel1 = null
            }
        },

        activeMenuLevel2Handle(item) {
            if (item.items) {
                this.activeMenuLevel2 = item
            }
            else {
                this.activeMenuLevel2 = null
            }
        },

        clearActive() {
            this.activeMenuLevel1 = null
            this.activeMenuLevel2 = null
        }
    }
}
</script>

<style lang="scss" scoped>
.header-nav-link {
    position: relative;
    display: flex;
    align-items: center;
    background-color: transparent;
    border: none;
    color: var(--header-color, #fff);
    text-decoration: none;
    height: 100%;

    padding-left: 15px;
    padding-right: 15px;
    gap: 6px;

    &:hover,
    &.active {
        color: var(--header-bg, #000);
        text-decoration: none;

        background-color: #fff;
        z-index: 100;
    }
}

.desktop-menu {
    position: absolute;
    top: 100%;
    left: 0;
    // opacity: 0;
    // transition: all .25s ease;
}

.menu-content {
    position: relative;
    background-color: #fff;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
    color: #1c1d1f;
}

.menuContainer {
    display: flex;
}

.browseNav {
    position: relative;
    display: flex;

    min-height: 300px;
}

.browseNavList {
    width: 260px;
    display: flex;
    flex-direction: column;

    padding: 0;
    margin: 0;
}

.browseNavList+.browseNavList {
    border-left: 1px solid #d1d7dc;
}

.browseNavItem {
    display: flex;
    flex-direction: column;

    margin: 0;
    padding: 0;
}

.browseNavLink {
    display: flex;
    align-items: center;

    text-decoration: none;

    text-align: left;
    letter-spacing: normal;
    white-space: normal;

    cursor: pointer;

    gap: 5px;

    font-size: var(--nav-font-size, 15px);
    color: var(--nav-font-color, #1c1d1f);

    padding: 10px 24px;
    padding-right: 18px;

    &:hover {
        background-color: #f2f2f2;
        color: var(--nav-font-hover-color, #712d7d);
    }

    .browseNavText {
        flex: 1;
        overflow: hidden;
    }

    .browseNavArrow {
        width: 24px;
        height: 24px;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        color: #999;
    }
}
</style>